import React from 'react';
import { Paragraph } from '@99designs/emu';

const SummaryCardItem = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <div className="card-summary-list__item" data-testid="card-summary-list-item">
        <div className="heading heading--h5">{title}</div>
        <Paragraph as="div" color="grey700">
            {children}
        </Paragraph>
    </div>
);

export default SummaryCardItem;
